export enum loggedValues {
    SHEETS = 'sheets',
    LOGGED = 'logged',
    NOLOGGED = 'nologged',
    MANAGER = 'manager',
    COMPRAS = 'compras',
};